import React from "react";
import { Select, TextField } from "shared";
import { SelectItem } from "shared/components/Input/type";
import t from "utils/Lang";
import { StoreListingFilterProps } from "../../type";

const StoreListingFilter = ({
  dataStatus,
  onFilter,
  currentStatus,
}: StoreListingFilterProps) => {
  const onSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    onFilter("search", event.target.value);
  };
  const status = dataStatus.find((s) => s.value == currentStatus);
  const onSelect = (type: "status") => (data: Array<SelectItem>) => {
    onFilter(type, data);
  };

  const SeparateItem = () => <div style={{ width: 10 }} />;

  return (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <div
        style={{
          flex: 1,
          flexWrap: "wrap",
          display: "flex",
          alignItems: "center",
        }}
      >
        <TextField
          style={styles.mt10}
          type="outline"
          placeholder={t().store_listing__search_name_placeholder}
          icon="search"
          onChange={onSearch}
        />
        <SeparateItem />
        <Select
          label={t().site_listing__status}
          data={dataStatus}
          style={styles.mt10}
          onChanged={onSelect("status")}
          editable
          values={(status && [status]) || []}
        />
      </div>
    </div>
  );
};

const styles = {
  mt10: { marginTop: 10 },
};

export default StoreListingFilter;
